import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';

import {SignatureMethodSelectComponent} from './signature-method-select.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    SignatureMethodSelectComponent
  ],
  exports: [
    SignatureMethodSelectComponent
  ]
})
export class SignatureMethodModule {
}
